<template>
  <L1 class="ingredients-list">
    <template slot="slot_title">
      <Select :width="'250px'" :defaultValue="type" @input="type=$event">
        <option :value="null">全部類別</option>
        <option v-for="t in types" :key="t" :value="t">{{t}}</option>
      </Select>
      <SearchInput :defaultValue="searchText" @input="searchText=$event"/>
      <RoundBtn @click="add=true" :style="{marginLeft: 'auto', marginRight: '32px'}" :icon="'add'" :text="'新增原料'" :bg="'var(--color-checked)'"/>
    </template>
    <div class="ingredients-body" :style="{marginInline: '18px 32px'}">
      <Table :rows="rows">
        <template slot="slot_head">
          <th :style="{textAlign: 'start'}">名稱</th>
          <th :style="{textAlign: 'start', width: '200px'}">類別</th>
          <th :style="{textAlign: 'center', width: '80px'}">單位</th>
          <th :style="{textAlign: 'start', width: '580px', paddingLeft: '402px'}">建立時間</th>
          <th :style="{textAlign: 'start', width: '180px'}">更新時間</th>
          <th :style="{width: '80px'}">編輯</th>
          <th :style="{width: '80px'}">刪除</th>
        </template>
        <tr slot-scope="{item,index}" :style="{height: '64px', border: 'none'}">
          <td :style="{textAlign: 'start'}">{{item.name}}</td>
          <td :style="{textAlign: 'start'}">{{item.type}}</td>
          <td :style="{textAlign: 'center'}">{{item.unit}}</td>
          <td :style="{textAlign: 'start', paddingLeft: '402px'}">{{toDate(item.createTime)}}</td>
          <td :style="{textAlign: 'start'}">{{toDate(item.updateTime)}}</td>
          <td><EditBtn @click="edit=item" :style="{margin: 'auto'}"/></td>
          <td><DelBtn @click="del(index)" :style="{margin: 'auto'}"/></td>
        </tr>
      </Table>
    </div>
    <dialogVue @close="add=false" :show="add" :width="'542px'" :height="'480px'" :label="'新增原料'">
      <div>
        <div class="field">
          <div>原料名稱</div>
          <input type="text" v-model="item.name" :style="{width: '400px'}">
        </div>
        <div class="field">
          <div>類別</div>
          <input type="text" id="type" list="type-list" v-model="item.type" :style="{width: '250px'}">
          <datalist id="type-list">
            <option v-for="t in types" :key="t" :value="t">{{t}}</option>
          </datalist>
        </div>
        <div class="field">
          <div>單位</div>
          <input type="text" list="unit-list" v-model="item.unit" :style="{width: '250px'}">
          <datalist id="unit-list">
            <option v-for="t in units" :key="t" :value="t">{{t}}</option>
          </datalist>
        </div>
        <Btns :style="{marginTop: '25px'}" @cancel="clean" @save="save"/>
      </div>
    </dialogVue>
    <dialogVue @close="edit=null" :show="!!edit" :width="'542px'" :height="'480px'" :label="'編輯原料'">
      <div v-if="edit">
        <div class="field">
          <div>原料名稱</div>
          <input type="text" v-model="edit.name" :style="{width: '400px'}">
        </div>
        <div class="field">
          <div>類別</div>
          <input type="text" id="type" list="type-list" v-model="edit.type" :style="{width: '250px', paddingLeft: '1.5em'}">
          <datalist id="type-list">
            <option v-for="t in types" :key="t" :value="t">{{t}}</option>
          </datalist>
        </div>
        <div class="field">
          <div>單位</div>
          <input type="text" list="unit-list" v-model="edit.unit" :style="{width: '250px', paddingLeft: '1.5em'}">
          <datalist id="unit-list">
            <option v-for="t in units" :key="t" :value="t">{{t}}</option>
          </datalist>
        </div>
        <Btns :style="{marginTop: '25px'}" @cancel="edit=null" @save="update"/>
      </div>
    </dialogVue>
  </L1>
</template>

<script>
import EditBtn from '../../../components/btn/edit.vue'
import DelBtn from '../../../components/btn/del.vue'
import Btns from '../../../components/btn/btns.vue'
import RoundBtn from '../../../components/btn/round.vue'
import SearchInput from '../../../components/input/search.vue'
import Select from '../../../components/select.vue'
import { getapi, putapi, deleteapi, postapi } from '../../../store/fetch'
import L1 from '../../../components/layout/L1.vue'
import Table from '../../../components/tables/t2.vue'
import dialogVue from '../../../components/dialog.vue'
export default {
  components: {
    L1,
    Table,
    Select,
    SearchInput,
    RoundBtn,
    dialogVue,
    Btns,
    EditBtn,
    DelBtn
  },
  data () {
    return {
      edit: null,
      add: false,
      rows: [],
      searchText: null,
      type: null,
      types: [],
      units: [],
      item: {
        name: null,
        type: null,
        unit: null
      }
    }
  },
  async mounted () {
    const [types, units] = await getapi('ingredients/types')
    this.types = types
    this.units = units
    await this.getdata()
  },
  methods: {
    clean () {
      this.item = {
        name: null,
        type: null,
        unit: null
      }
      this.add = false
    },
    async del (index) {
      const { _id } = this.rows[index]
      const r = await deleteapi(`ingredients/${_id}`)
      if (r) {
        this.rows.splice(index, 1)
      }
    },
    async update () {
      const { name, type, unit, _id } = this.edit
      const r = await postapi(`ingredients/${_id}`, { name, type, unit })
      const index = this.rows.map(e => e._id).indexOf(_id)
      if (r) {
        this.rows.splice(index, 1, r)
        this.edit = null
      }
    },
    async save () {
      const r = await putapi('ingredients', { ...this.item })
      const [types, units] = await getapi('ingredients/types')
      this.types = types
      this.units = units
      this.rows.splice(0, 0, r)
      this.item = {
        name: null,
        type: null,
        unit: null
      }
      this.add = false
    },
    async getdata () {
      const params = {}
      if (this.searchText) {
        params.searchText = this.searchText
      }
      if (this.type) {
        params.type = this.type
      }
      this.rows = await getapi(`ingredients?${new URLSearchParams(params)}`)
    }
  }
}
</script>
<style lang="scss">
.ingredients-list {
  .L1_title {
    border-bottom: none!important;
  }
}
</style>
<style lang="scss" scoped>
.ingredients-body {
  border-top: 1px solid #CACACA;
}
.field {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 3px;
  &>div:nth-child(1) {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
    letter-spacing: 0.05em;
    color: #787878;
  }
  input[type=text] {
    height: 45px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: #000000;
    text-align: center;
  }
}
</style>
